<script>
  /**
   * 横田工業 日報 コンポーザー
   *  - DB の初期化
   *  - 日付の選択
   *  - 日報を DB から読み込み
   *  - 日報を DB へ保存
   *  - 報告者の選択
   */
  import { onMount } from 'svelte'
  import getUrlParams from '../modules/getUrlParams'
  import { create, fetch } from '../modules/dateUlidDocument'

  import LoadingIndicator from '../components/LoadingIndicator.svelte'
  import ModalCard from '../components/ModalCard.svelte'
  import FirebaseInit from '../components/firestore/FirebaseInit.svelte'
  import DateInput from '../components/firestore/inputs/DateInput.svelte'
  import YokotaReportEditor from '../components/firestore/YokotaReportEditor.svelte'

  const path = 'yokota' // ドキュメント コレクションへのパス

  let db // Firestore のインスタンス
  let date // 日付
  let dateCache // 日付のキャッシュ
  let data // 編集中の日報
  let isSubmitting = false // 保存中フラグ
  let modal // 保存通知モーダル保持用

  onMount(() => {
    // URL パラメータから日付指定を取得
    const params = getUrlParams()
    if (params.date) {
      date = params.date
    }
  })

  // 新たな日付が指定されたら
  $: if (db && date && date !== dateCache) {
    // 現在の日付をキャッシュして重複処理を防ぐ
    dateCache = date
    // 編集中の日報を破棄
    data = null
    // 日報を取得
    fetch({ db, path, date }).then(doc => {
      const reportId = doc?.id
      console.log({ reportId })
      // データのセット || データがない場合は初期化
      data = doc?.data() || {}
    })
  }

  // 日報を新規作成して保存
  const createReport = async () => {
    isSubmitting = true

    const reportId = await create({ db, path, date, data })
    console.log({ reportId })

    isSubmitting = false
    modal.show()
  }
</script>

<h1>横田工業 日報 <i class="fas fa-eye-slash" /></h1>

<!-- 日付の選択 -->
<div class="box has-background-primary-light">
  <DateInput id="yokota" label="日付" bind:value={date} />
</div>

<hr />

<FirebaseInit bind:db>
  {#if !data}
    <LoadingIndicator>読込中...</LoadingIndicator>
  {:else}
    <p>
      <YokotaReportEditor {date} bind:data />
    </p>

    <div class="buttons is-right">
      <button
        type="submit"
        class="button is-link"
        data-testid={`createReportButton`}
        class:is-loading={isSubmitting}
        disabled={isSubmitting}
        on:click={createReport}>保存</button
      >
    </div>
  {/if}
</FirebaseInit>

<ModalCard
  name="saveCompleteDialog"
  title="保存完了"
  isCancelButtonVisible={false}
  bind:this={modal}>今日も一日お疲れ様でした！</ModalCard
>
